import AddUserRightsInput from './AddUserRightsInput'

const AddUserRowsCol = ({disabled,checked,name,func}) => {
  return (
    <td class="table-data"><AddUserRightsInput disabled={disabled} checked={checked} name={name} func={func}/></td>
  )
}

export default AddUserRowsCol
